import { ModalKey } from "@/stores/ModalStore/ModalKey.ts";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

type AtLeastOne<T, U = { [K in keyof T]: Pick<T, K> }> = Partial<T> & U[keyof U];

type OpenModalParams = AtLeastOne<{
  key: ModalKey;
  editObj: unknown;
}>;

export interface ModalStoreState {
  open: boolean;
  // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
  editObj: unknown | null;
  key: ModalKey | null;

  openModal: (params?: OpenModalParams) => void;
  setEditObj: (editObj: unknown) => void;
  closeModal: () => void;
}

/**
 * Generic store that can be used instead useModalState for easier state management
 * Usage examples
 * openModal()
 * openModal({ key: ModalKey.EDIT_USER })
 * openModal({ editObj: { id: 1, name: 'John' } })
 * openModal({ key: ModalKey.EDIT_USER, editObj: { id: 1 } })
 */
export const useModalStore = create<ModalStoreState>()(
  devtools(
    (set) => ({
      open: false,
      editObj: null,
      key: null,

      openModal: (params?: OpenModalParams) => {
        if (params) {
          set({
            open: true,
            editObj: params.editObj ?? null,
            key: params.key ?? null,
          });
        } else {
          set({ open: true, editObj: null, key: null });
        }
      },
      // True any
      // eslint-disable-next-line
      setEditObj: (editObj: any) => set({ editObj }),
      closeModal: () => set({ open: false, editObj: null, key: null }),
    }),
    { name: "ModalStore" },
  ),
);
